import { Title } from '@shared/ui';
import { InvoiceGeneratorMenu } from '@modules/invoice-generator';
import { containerStyle } from './InvoiceGenerator.tailwind';
import { ExecutionReportsSection } from './ui/ExecutionReportSection';

const InvoiceGeneratorPage = () => {
  return (
    <div className={containerStyle}>
      <Title text="Invoice Generator" className="mb-8" />
      <InvoiceGeneratorMenu />
      <ExecutionReportsSection />
    </div>
  );
};

export default InvoiceGeneratorPage;
